import { type PublicClip } from '@air/api';
import { type AssetCustomFieldValue, type FormField } from '@air/api/types';

export const getCustomFieldValue = ({ value, values, plainTextValue, dateValue }: AssetCustomFieldValue) =>
  value || values || plainTextValue || dateValue;

export const getClipFormFieldValue = (clip: PublicClip, field: FormField) => {
  if (field.type === 'description') {
    return clip.description;
  } else if (field.type === 'title') {
    return clip.title;
  } else {
    return clip.customFields?.find((cf) => cf.id === field.customFieldId && getCustomFieldValue(cf));
  }
};
